import React from "react";

export default function SQL_Selects() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_SELECT</h1>
      <p>This is the SQL_SELECT component generated from the SQL JSON.</p>
    </div>
  );
}
